            
<template>        
  <b-row style="padding-top: 10px;">   
    <b-col class="text-right">
        <b-button 
          v-if="limpiar" 
          v-ripple="'rgba(255, 255, 255, 0.10)'" 
          size="sm" 
          class="ml-2" 
          @click="limpiarEmit()" 
        >  Limpiar </b-button> 

        <b-button
          v-if="(index===false || index===10000) && agregar"  
          v-ripple="'rgba(255, 255, 255, 0.10)'" 
          @click="save(true); " 
          variant="outline-primary" 
          :disabled="invalid || disabledFtn()" 
          size="sm" 
          class="ml-2" 
         > Agrupar {{nameBtn}} </b-button>

        <b-button  
          v-if="((index===false || index===10000) && dataPost[namePath].data.length===0 && saveConfig.capa===false && actualizar===false)  && getBackendData===false  && saveConfig.saveloading===false && promiseSave===false" 
          v-ripple="'rgba(255, 255, 255, 0.10)'" 
          @click="save(false);"  
          :disabled="invalid || disabledFtn()" 
          variant="success" 
          size="sm" 
          class="ml-2" 
          >  Guardar {{nameBtn}}</b-button>

        <b-button  
          v-if="index===10000 && dataPost[namePath].data.length>0 && saveConfig.saveloading===false && promiseSave===false && saveConfig.capa===false && actualizar===false && getBackendData===false" 
          v-ripple="'rgba(255, 255, 255, 0.10)'" 
          @click="save(false);"  
          :disabled="invalid || disabledFtn()" 
          variant="success" 
          size="sm" 
          class="ml-2" 
          >  Guardar {{nameBtn}}</b-button>
        
        <b-button  
          v-if="getBackendData || ((saveConfig.saveloading || promiseSave) && saveConfig.capa && actualizar===false && (index===false || index===10000))" 
          disabled 
          variant="success" 
          size="sm" 
          class="ml-2 sw-save-loading" 
          ><div> <b-spinner variant="light" label="Spinning"></b-spinner></div>Guardar {{nameBtn}}</b-button>

        <b-button 
          v-if="(index!==false && index!==10000) && saveConfig.saveloading===false && promiseSave===false &&  actualizar" 
          v-ripple="'rgba(255, 255, 255, 0.10)'" 
          @click="actualizarFtn()" 
          variant="primary" 
          :disabled="invalid" 
          size="sm" class="ml-2" 
          > Actualizar {{nameBtn}}</b-button>
        
        <b-button 
          v-if="saveConfig.saveloading===false && promiseSave===false && actualizar===false && saveConfig.capa===false && (index!==false && index!==10000)" 
          v-ripple="'rgba(255, 255, 255, 0.10)'" 
          @click="save(false);" 
          :disabled="invalid  || disabledFtn()" 
          variant="primary" 
          size="sm" 
          class="ml-2"  
          > Actualizar {{nameBtn}}</b-button>
          
        <b-button  
          v-if="((saveConfig.saveloading || promiseSave) && actualizar===false && (index!==false && index!==10000)) || (saveConfig.capa && actualizar===false && (index!==false && index!==10000))" 
          disabled 
          variant="primary" 
          size="sm" 
          class="ml-2 sw-save-loading" 
          ><div> <b-spinner variant="light" label="Spinning"></b-spinner></div>Actualizar {{nameBtn}}</b-button>
        
        <b-button 
          v-if="cerrar" 
          v-ripple="'rgba(255, 255, 255, 0.10)'" 
          size="sm" 
          class="ml-2" 
          @click="cerrarEmit()" 
        >  Cerrar </b-button> 
    </b-col>
  </b-row>              
</template>
<script>
import { mapState, mapActions } from "vuex"
export default 
{
  name: 'swfooterform',
  props:{
    guardarFtn: {
      type: String,
      default: 'guardarFtn'
    },
    limpiar: {
      type: Boolean,
      default: false
    },
    nameBtn: {
      type: String,
      default: ''
    },
    actualizar: {
      type: Boolean,
      default: false
    },
    agregar: {
      type: Boolean,
      default: false
    },
    cerrar: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    },
    index: {
      default: false
    },
    disabled: {
      type: Array,
      default: function ()
      {
        return []
      }
    },
    getBackendData: {
      default: false
    }
  },
  data()
  {
    return {
      promiseSave: false
    }
  },
  async created () 
  {    
      await this.updateGlobal({state: 'saveConfig/saveloading', data: false})
  },
  computed: {    
  },
  methods: {
    cerrarEmit()
    {
      this.$emit('cerrar')
    },
    limpiarEmit()
    {
      this.$emit('limpiar')
    },
    disabledFtn()
    {
      if(this.disabled.length===0)
      {
        return false
      }
      else 
      {
        let esperar = false
        for (let i = 0; i < this.disabled.length; i++) {
          if(this.dataForm[this.namePath][this.disabled[i]].length===0)
          {
            esperar = true            
          }          
        }
        return esperar
      }
      
    },
    async actualizarFtn()
    {
      this.promiseSave=true
      await this.updateGlobal({state: 'saveConfig/saveloading', data: true})
      this.promiseSave=false
      this.$emit('actualizar')
    },
    async save(value)
    {
      this.promiseSave=true
      await this.updateGlobal({state: 'saveConfig/saveloading', data: true})
      this.promiseSave=false
      this.$emit('save',{save: value, ftn: this.guardarFtn})
    },
    async saveNotify(error,color,title=false,content=false)
		{
			try{
				if(error) {
					await this.changeGlobal({ state: 'saveConfig/notification/error', boolean: true})
					await this.updateGlobal({ state: 'saveConfig/notification/title', data: 'No se guardaron los datos, intentalo de nuevo'})
				}
				if(content!==false) {
					await this.updateGlobal({ state: 'saveConfig/notification/content', data: content})
				}
				if(title!==false) {
					await this.updateGlobal({ state: 'saveConfig/notification/title', data: title})
				}
				await this.updateGlobal({ state: 'saveConfig/notification/color', data: color})
				await this.changeGlobal({ state: 'saveConfig/notification/view',  boolean: true})
				return !error
			}catch {

			}
		}, 
  }
}
</script>
<style>
.sw-save-loading{
  position:relative;
  color:transparent !important;
}
.sw-save-loading div{
  position: absolute;
  left: 0;
  right: 0
}
.sw-save-loading .spinner-border{
  width: 20px;
  height : 20px;
  border: 0.15em solid currentColor;
  border-right-color: transparent;
}
</style>